import { cn } from '@atlas/ui-primitives'
import { RULE_SEVERITY_LABEL, RuleSeverity } from '@/domain/rules.types'

export interface RuleSeverityPillProps {
	severity: RuleSeverity
	className?: string
	/** Adds a border colored to match the severity (danger/warning), not neutral gray. */
	bordered?: boolean
}

/**
 * Severity indicator for a rule (design §8.13): a colored dot + uppercase mono label.
 * Blocking → danger, Warning → warning.
 * Presentational + storied.
 */
export function RuleSeverityPill({ severity, className, bordered }: RuleSeverityPillProps) {
	const blocking = severity === RuleSeverity.BLOCKING
	return (
		<span
			className={cn(
				'inline-flex items-center gap-1.5 rounded-ds-full bg-ds-surface px-2 py-0.5 font-mono text-ds-2xs uppercase tracking-wide',
				bordered && (blocking ? 'border border-ds-danger-strong' : 'border border-ds-warning'),
				className,
			)}
		>
			<span className={cn('h-1.5 w-1.5 rounded-ds-full', blocking ? 'bg-ds-danger' : 'bg-ds-warning')} />
			<span className={blocking ? 'text-ds-danger-strong' : 'text-ds-warning'}>{RULE_SEVERITY_LABEL[severity]}</span>
		</span>
	)
}
